import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { chargeSlabQueries } from '@/services/chargeSlab/chargeSlab.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useToggleChargeDetailStatus = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('toggleChargeDetailStatus', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: chargeSlabQueries.all() });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync, isPending };
};

export default useToggleChargeDetailStatus;
